/* 標準的な行のテンプレート */
import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

interface Props {
  label: string;
  need?: boolean;
  content: any;
  disabled?: boolean;
  looks_inactive?: boolean;
  show?: boolean;
  display_border?: boolean;
}
const RowTemplate: React.FC<Props> = ({
  label,
  need,
  content,
  disabled,
  looks_inactive,
  show,
  display_border,
}) => {
  /**
   * 必須マークの表示を制御する
   * @return boolean
   */
  const isVisibleRequiredMark = () => {
    // null, undefinedの場合はdisabled === falseであるものとみなす
    return !disabled && !looks_inactive && need;
  };
  return (
    <Form.Row className={show === false ? 'd-none' : ''}>
      <Col md={4} className="field-label">
        {label}
        {isVisibleRequiredMark() ? (
          <span className="c-required-item-label ml-md-auto">必須</span>
        ) : null}
      </Col>
      <Col
        md={8}
        className={`field-label-text ${!looks_inactive && !display_border && 'field-border-none'}`}
      >
        {content}
      </Col>
    </Form.Row>
  );
};

export default RowTemplate;
